// The review continuation, compact, riding the PageHeader `actions` slot of
// the transcript canvas: `N labeled this session · ◀ i of N ▶ · Return`.

import { Button, Inline, InlineError, Text } from "../../ui";

export function ReviewFeedBand({
  ended,
  error,
  hasPrevious,
  isPending,
  labelsSaved,
  onNext,
  onPrevious,
  onReturn,
  onRetry,
  position,
}: {
  ended: boolean;
  error: string | null;
  hasPrevious: boolean;
  isPending: boolean;
  labelsSaved: number;
  onNext: () => void;
  onPrevious: () => void;
  onReturn?: () => void;
  onRetry: () => void;
  position: string;
}) {
  return (
    <Inline className="marker-review-band" gap={2}>
      {error ? (
        <>
          <InlineError>{error}</InlineError>
          <Button size="sm" type="button" variant="ghost" onClick={onRetry}>
            Retry
          </Button>
        </>
      ) : null}
      <Text as="span" variant="muted">
        {String(labelsSaved)} labeled this session
      </Text>
      <Text as="span" className="marker-review-band__separator" variant="muted">
        ·
      </Text>
      <Button
        aria-label="Previous call"
        disabled={!hasPrevious || isPending}
        size="sm"
        type="button"
        variant="ghost"
        onClick={onPrevious}
      >
        ◀
      </Button>
      <Text as="span" className="marker-review-band__position" variant="small">
        {ended ? "End of selection" : position}
      </Text>
      <Button
        aria-label="Next call"
        disabled={ended || isPending}
        size="sm"
        type="button"
        variant="ghost"
        onClick={onNext}
      >
        ▶
      </Button>
      <Text as="span" className="marker-review-band__separator" variant="muted">
        ·
      </Text>
      <Button
        disabled={isPending}
        size="sm"
        type="button"
        variant={ended ? "primary" : "secondary"}
        onClick={onReturn}
      >
        Return
      </Button>
    </Inline>
  );
}
